import { fromJS } from '@gonfalon/immutable-shim/immutableShim';

import { HunkRecord } from './records/HunkRecord';

export function createHunk(props = {}) {
  const hunk = props instanceof HunkRecord ? props : new HunkRecord(fromJS(props));
  // Remove only trailing newlines from hunk lines to make sure weird artifacts aren't added to the PrismJS Snippet
  // Remove all carriage returns because PrismJS doesn't like them
  return hunk.update('lines', (lines) => lines.replace(/[\r\n]+$/g, '').replace(/\r/g, ''));
}
